// encode 'hoge 20190821@photocreate.com' to 'hoge+20190821@photocreate.com'
export function encodeEmail(email: string) {
  const nativeEncoded = encodeURI(email)
  const replaced = nativeEncoded.replace('%20', '+')
  return replaced
}
